import React, { useEffect, useState } from 'react'
import MainButton from '../common/util/input/MainButton'
import { Skeleton } from '@nextui-org/react'
import Link from 'next/link'
import get from '../helpers/Api'
import BlogCard from '../blogs/BlogCard'

const NewsAndStories = () => {
    const [news, setNews] = useState([])
    const [isLoading, setLoading] = useState(true)

    const getNews = () => {
        get(`news?limit=4`, 'news-api')
            .then((response) => setNews(response))
            .catch((error) => console.error(error))
    }

    useEffect(() => {
        if (typeof window !== 'undefined') {
            getNews()
            setLoading(false)
        }
    }, [])

    return (
        <>
            <div className="flex items-center justify-between ">
                <h2 className="font-bold p-2  text-[28px] lg:text-[30px]">
                    News and Stories
                </h2>
                <Link href="/blogs">
                    <MainButton
                        color="primary"
                        variant="solid"
                        className="uppercase"
                    >
                        View All
                    </MainButton>
                </Link>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-2 sm:gap-4 p-2 mt-2">
                {!isLoading
                    ? news?.map((blogItem, index) => (
                          <BlogCard
                              key={index}
                              id={blogItem?.id}
                              feedImage={blogItem?.feedImage}
                              storyImage={blogItem?.storyImage}
                              title={blogItem?.storyTitle}
                              summary={blogItem?.summary}
                              timestamp={blogItem?.timestamp}
                              category={blogItem?.category}
                              author={blogItem?.author}
                          />
                      ))
                    : Array.from(new Array(4)).map(() => (
                          <div className="space-y-4 p-4">
                              <Skeleton className="w-full h-[200px] rounded-lg">
                                  <div className="h-24 rounded-lg bg-default-300"></div>
                              </Skeleton>
                              <Skeleton className="w-full h-[54px] rounded-lg">
                                  <div className="h-24 rounded-lg bg-default-300"></div>
                              </Skeleton>
                              <Skeleton className="w-full h-[60px] rounded-lg">
                                  <div className="h-24 rounded-lg bg-default-300"></div>
                              </Skeleton>
                              <Skeleton className="w-1/2 h-[24px] rounded-lg">
                                  <div className="h-24 rounded-lg bg-default-300"></div>
                              </Skeleton>
                          </div>
                      ))}
            </div>
        </>
    )
}

export default NewsAndStories
